<template>
  <div class='historyDialog'>
    <div class="historyDialog-flex">
      <!-- 顶部按钮 -->
      <div class="historyDialog-header">
        <div class="flex-main-container">
          <el-button class="confirm-btn-plain addDialogBtn" plain @click="newDialog">{{ $i18.language("新建对话") }}</el-button>
          <div class="video-teach-box" v-if="$util.judgeOrigin()=='DF'" @click="clickVideo">
            <svg-icon name="video-teach" class="newIcon"></svg-icon>
            <span>{{$i18.language('视频教学')}}</span>
          </div>
        </div>
        <template>
          <el-divider></el-divider>
          <el-input class="search" size="mini" :placeholder="$t('tableComponent.search')" @keyup.enter.native="changeSearch" @blur="changeSearch" :maxlength="10" v-model="keyword">
            <i @click="changeSearch" slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </template>
      </div>
      <!-- 历史列表 -->
      <div class="historyDialog-list" v-loading="loading" :element-loading-text="$t('message.loading')+'...'">
        <RecycleScroller class="recycleScroller" :items="filteredHistoryList" :item-size="40" v-slot="{ item }" key-field="id">
          <div :class="[actDialogId==item.id?'actived':'', 'content-title']" @click="changeActDialog(item)">
            <template v-if="editVisibleId == item.id">
              <el-input v-model="newTitleValue" ref="inputRef" @click.stop.native @keyup.enter.native="handleInputConfirm(item)" @blur="handleInputConfirm(item)"></el-input>
            </template>
            <template v-else>
              <div class="isSticktop">
                <svg-icon v-if="item.top" name="sticktop"></svg-icon>
              </div>
              <div class="title-text">
                <span :title="item.title">{{ item.title }}</span>
              </div>
              <div class="op">
                <div @click.stop="top(item)" class="op-item" :class="item.top?'isTop':''">
                  <svg-icon name="sticktop"></svg-icon>
                </div>
                <div @click.stop="edit(item)" class="op-item">
                  <svg-icon name="edittitle"></svg-icon>
                </div>
                <div @click.stop="del(item)" class="op-item">
                  <svg-icon name="deldialog"></svg-icon>
                </div>
              </div>
            </template>
          </div>
        </RecycleScroller>
      </div>
    </div>
    <!-- //当前视频弹窗 -->
    <help-video ref="helpVideo" :currentVideo="currentVideo" :saveTime="false" @clearVideo="clearVideo"></help-video>
  </div>
</template>

<script>
import helpVideo from '@/views/helpCenter/helpVideo.vue';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { RecycleScroller } from 'vue-virtual-scroller';

export default {
  components: {
    helpVideo,
    RecycleScroller
  },
  data() {
    return {
      loading: false,
      actDialogId: '',
      historylist: [],
      keyword: '',
      editVisibleId: '', 
      newTitleValue: '', // title输入框的值
      inputConfirming: false, // 是否在修改title中
      currentVideo: {},
      filteredHistoryList: []
    };
  },
  created() {
    this.getHistoryDialog()
  },
  methods: {
    // 获取当前用户的历史会话
    getHistoryDialog(sessionKey){
      this.loading = true
      this.$api.ai.getGptSession().then(res => {
        this.historylist = this.filteredHistoryList = res.data
        this.loading = false
        if (sessionKey && res.data && res.data.length > 0) { // 处理新对话 并更改当前会话
          this.actDialogId = res.data.filter(e=>e.sessionKey==sessionKey)[0].id
        }
      })
    },
    // 搜索会话
    changeSearch(){
      this.filteredHistoryList = this.keyword ? this.historylist.filter(e => e.title.includes(this.keyword)) : this.historylist;
    },
    // 关闭视频弹框
    clearVideo() {
      this.currentVideo = {}
    },
    // 打开视频教学
    clickVideo() {
      let onlyKey = localStorage.getItem('language') == 'en'?'gt6_aigpt_1_en':'gt6_aigpt_1_cn'
      this.$api.help.getProductHelpList({ onlyKey}).then((res) => {
        if (res && res.code == 200) {
          let list = res.data || []
          let currentVideo = list.find(item=>item.appKey=='GT6_Video_Helper')
          if(currentVideo) {
            this.currentVideo = currentVideo
            this.$refs.helpVideo.open()
          } else {
            this.$message.warning(this.$i18.language('当前没有视频教学'))
          }
        }
      })
    },
    // 新建会话
    newDialog(){
      this.actDialogId = ''
      this.$emit('newDialog')
    },
    // 更改当前会话
    changeActDialog(row){
      this.actDialogId = row.id //当前选中的actDialogId
      this.$emit('changeActDialog', row)
    },
    // 完成编辑
    handleInputConfirm(row){
      if (this.inputConfirming) {
        return false;
      } else {
        this.inputConfirming = true
      }
      this.editVisibleId = ''
      let params = {
        id: row.id,//会话id
        type: 2,// 操作类型，1置顶，2修改，3删除
        title: this.newTitleValue
      }
      this.$api.ai.updateSession(params).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('message.success.modifySuccess'))
          this.getHistoryDialog()
        }
      }).finally(()=>{this.inputConfirming = false})
    },
    // 置顶
    top(row){
      this.loading = true
      let params = {
        id: row.id,//会话id
        type: 1,// 操作类型，1置顶，2修改，3删除
      }
      this.$api.ai.updateSession(params).then(res => {
        if (res.code == 200) {
          this.getHistoryDialog()
          // this.$message.success(this.$t('message.success.topSuccess'))
        }
      })
    },
    // 删除
    del(row){
      this.loading = true
      let params = {
        id: row.id,//会话id
        type: 3,// 操作类型，1置顶，2修改，3删除
      }
      this.$api.ai.updateSession(params).then(res => {
        if (res.code == 200) {
          this.getHistoryDialog()
          this.$message.success(this.$t('message.success.deleteSuccess'))
          if (this.actDialogId == row.id) {
            this.newDialog()
          }
        }
      })
    },
    edit(row){
      this.editVisibleId = row.id
      this.newTitleValue = row.title
      // 获取当前输入框的焦点
      this.$nextTick(()=>{
        this.$refs.inputRef.focus()
      })
    },
  },
};
</script>

<style scoped lang="scss">
/* 其他样式保持不变 */
.historyDialog{
  height: calc(100vh - 140px);
  margin: 15px 10px 35px 35px;
  padding: 15px;
  width: 16vw;
  min-width: 120px;
  // min-height: 440px;
  background-color: $--color-white;
  border-radius: 15px;
  overflow-y: hidden;
  &:hover {
    overflow-y: auto;
  }
  // background-color: $--background-color-base;
  .historyDialog-flex {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    overflow-y: inherit;
    .historyDialog-header {
      width: 100%;
      .addDialogBtn {
        border-radius: 5px;
      }
      /deep/ .el-divider--horizontal {
        margin: 10px 0;
      }
      /deep/.search {
        width: 100%;
        .el-icon-search {
          cursor: pointer;
        }
      }
    }
    .historyDialog-list {
      width: 100%;
      overflow-y: inherit;
      overflow-x: hidden;
      .recycleScroller {
        height: 100%;
        &::-webkit-scrollbar {
          width: 5px; /* Chrome Safari */
        }
        &::-webkit-scrollbar-thumb {
          background: $--scrollbar-thumb-color; // 滑块颜色
          border-radius: 5px; // 滑块圆角
        }
        &::-webkit-scrollbar-thumb:hover {
          background: $--scrollbar-thumb-hover-color; // 鼠标移入滑块hover
        }
        .actived{
          background-color: $--color-input-hover;
          transition: all .2s ease-in;
          .op {
            display: flex;
            flex: 1;
            justify-content: flex-end;
          }
        }
        .content-title {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin: 5px 0;
          border-radius: 5px;
          transition: all .2s ease-in;
          padding-right: 5px;
          cursor: pointer;
          &:hover {
            background-color: $--color-input-hover;
            transition: all .2s ease-in;
            .op {
              display: flex;
              flex: 1;
              justify-content: flex-end;
            }
          }
          .title-text {
            padding: 0 0 0 5px;
            overflow: hidden;
            height: 30px;
            line-height: 30px;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          /deep/ .el-input__inner {
            font-size: 15px;
            border: 0;
            border-radius: 5px;
            background-color: $--color-input-hover;
            padding-left: 8px;
            height: 30px;
            line-height: 30px;
          }
          .op {
            display: none;
            .op-item {
              display: flex;
              align-items: center;
              justify-content: center;
              &:hover {
                color: $--color-active-6;
              }
            }
            .isTop {
              color: $--color-link !important;
            }
            svg {
              padding-left: 8px;
            }
          }
        }
      }
    }
  }
}
</style>
